<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Resize your browser window and observe the changes in the data" />
    <div v-resize="resize" :class="['mt-16']">
      <code>{{ dimensions }}</code>
    </div>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'ResizePage',
  data () {
    return {
      title: null,
      description: null,
      dimensions: {}
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getPage()
  },
  methods: {
    resize () {
      this.dimensions = this.viewport()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/resize.vue